// extracted by mini-css-extract-plugin
export var inverted = "Rs1qeZ2qjLvqx1U0ot6Z";
export var large = "S9t6rAoo8dAAO66PDkzB";
export var root = "zSk31N4rcSR4Qqj7gZsl";
export var spin = "lYgyXF5i4oqDarI0ty9X";